<template>
    <div class="form-input-container">
      <div class="form-title"><label for="id">{{translate(label)}} <span class="required" v-if="required">*</span></label></div>
      <input class="form-input" @input="$emit('input', $event.target.value)" :disabled="disabled">
    </div>
  </template>
  <script>
    export default {
      name: 'stats-card',
      props: {
        label: {
          type: Array,
          default: ''
        },
        required: {
          type: Boolean,
          default: true
        },
        disabled: {
          type: Boolean,
          default: false
        }
      }
    }
  </script>
  
  <style scoped>
    .form-input-container {
      margin-bottom: 12px;
    }
  
    .form-title {
      margin-bottom: 8px;
    }
  
    .form-input {
      width: 100%;
      height: 38px;
      font-size: 14px;
      padding: 4px 12px;
      border: 1px solid #BBB;
      border-radius: 6px;
      font-family: "Open Sans", "Hanuman", sans-serif;
      color: #112d9b;
    }
  
    .form-input:focus {
      border: 1px solid #112d9b;
    }
  </style>


// WEBPACK FOOTER //
// src/components/Form/File.vue